/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Weekly long-term retention policy settings.
 */
export interface BackupServerBackupGFSPolicySettingsWeekly { 
    /**
     * Indicates whether the weekly long-term retention policy is enabled.
     */
    isEnabled: boolean;
    /**
     * Number of weeks during which restore points must be stored.
     */
    keepForNumberOfWeeks?: number | null;
    /**
     * Day of the week when the weekly retore point must be created.
     */
    desiredTime?: BackupServerBackupGFSPolicySettingsWeeklyDesiredTime | null;
}
export enum BackupServerBackupGFSPolicySettingsWeeklyDesiredTime {
    Sunday = 'Sunday',
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday'
};



